import React from 'react'
import t from '../../translations/i18n'

export default function Services () {
  return (
    <>
      <section id="services" className="services section-bg">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{t('sections.services_tittle_one')}</h2>
            <p>{t('sections.services_subtittle_one')}</p>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box">
                <div className="icon"><i className="bx bxl-jsfiddle"></i></div>
                <h4 className="title"><a href="!#">{t('sections.services_tittle_two')}</a></h4>
                <p className="description">{t('sections.services_subtittle_two')}</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="200">
              <div className="icon-box">
                <div className="icon"><i className="bx bx-file"></i></div>
                <h4 className="title"><a href="!#">{t('sections.services_tittle_three')}</a></h4>
                <p className="description">{t('sections.services_subtittle_three')}</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="300">
              <div className="icon-box">
                <div className="icon"><i className="bx bx-tachometer"></i></div>
                <h4 className="title"><a href="!#">{t('sections.services_tittle_four')}</a></h4>
                <p className="description">{t('sections.services_subtittle_four')}</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="400">
              <div className="icon-box">
                <div className="icon"><i className="bx bx-world"></i></div>
                <h4 className="title"><a href="!#">{t('sections.services_tittle_five')}</a></h4>
                <p className="description">{t('sections.services_subtittle_five')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
